import React, {Component} from 'react';
import {injectIntl} from 'react-intl';

import {connect} from 'react-redux';
import {Row, Col} from 'react-bootstrap';

import LanguageSelect from 'containers/ui/select/LanguageSelect';
import RecoverPasswordFormContainer from 'containers/login/RecoverPasswordFormContainer';

const logoUrl = require('img/equinix_logo.svg');

/** The Recover password component */
class RecoverPassword extends Component {

    /**
     * Makes an api request to verify the status of the applicationi before the password submit to see if the key in
     * the url is correct or if there is internet connection to verify that we can show the form or not.
     */

    render() {
        const {params: {recoveryKey, uid}} = this.props.match;

        return (<div>
            <div className="container login-container">
                <Row>
                    <Col sm={4}>
                        <div className="login-logo">
                            <img alt="logo2" src={logoUrl}/>
                        </div>
                    </Col>
                    <Col sm={6} lg={5}>
                        <LanguageSelect className="pull-right"/>
                        <RecoverPasswordFormContainer recoverKey={recoveryKey} uid={uid}/>
                    </Col>
                </Row>
            </div>
        </div>);
    }
}

export default connect()(injectIntl(RecoverPassword));



// WEBPACK FOOTER //
// ./src/routes/RecoverPassword.jsx